import * as t from 'io-ts';
import * as tp from 'io-ts-promise';
import axios from 'axios';
import { AxiosResponse } from 'axios';

import Data from '../../Data';
import Endpoints from '../endpoints';
import { getDataFromAxios } from '../common';
import { UserListResponse } from './response_models';

export const loadUserList = (pageSize: number, currentPage: number): Promise<AxiosResponse<UserListResponse>> =>
  axios.get(Endpoints.users.LIST(pageSize, currentPage), Data.async.authorisationHeaders());

export default async (pageSize: number, currentPage: number) =>
  await loadUserList(pageSize, currentPage).then(getDataFromAxios.get).then(tp.decode(UserListResponse));
